const sanitizeFilename = (filename: string): string => {
  // Convert to lowercase
  filename = filename.toLowerCase()

  // Replace spaces with underscores and replace non-alphanumeric characters (except dashes) with underscores
  filename = filename
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .replace(/[^a-z0-9-]/g, '_') // Replace all non-alphanumeric characters except dashes with underscores
    .replace(/_+/g, '_') // Replace multiple underscores with a single underscore

  return filename
}

export const formatFilename = ({
  extension,
  nameParts,
}: {
  extension: string
  nameParts: string[]
}) => {
  // Cap each part in the array at 16 characters
  const sanitizedParts = nameParts.map((part) => part.substring(0, 16))

  // Join the parts with underscores
  const fileName = sanitizedParts.join('_')

  // Sanitize the final file name and append the extension
  return `${sanitizeFilename(fileName)}.${extension}`
}

export const nonLinebreakingSpace = '\u00A0'

export const splitLastWord = (text: string) => {
  const match = text.match(/^(.*?)(\s+)(\S+)$/)
  if (!match) return [text, '']
  return [match[1], match[3]]
}

export const EMDASH = '—'

/**
 *
 * @param a Anything - it will only compare if it's a string, but is safe to run with unknown types
 * @param b The string to search for in a, case-insensitively
 * @returns True if a is a string and includes b (case-insensitive), false otherwise
 * @example
 * safeIncludes("Hello World", "world") // returns true
 * safeIncludes("Hello World", "WORLD") // returns true
 * safeIncludes("Hello World", "hello") // returns true
 * safeIncludes("Hello World", "test") // returns false
 * safeIncludes(12345, "123") // returns false (because a is not a string)
 * safeIncludes(null, "test") // returns false (because a is not a string)
 * safeIncludes(undefined, "test") // returns false (because a is not a string)
 */
export function safeIncludes(a: unknown, b: string) {
  if (typeof a !== 'string') return false
  return a.toLowerCase().includes(b)
}
